<template>
  <select v-if="visible" v-model="value" class="fd-unmask" :class="clazz" :style="style">
    <option value="">{{ env.msg('formEditor.addField') }}</option>
    <option v-for="li in maskedList" :value="li.value">{{ li.name }}</option>
	  <option v-if="maskedMany" :value="UNMASK_ALL">{{ env.msg('formEditor.unmaskAll') }}</option>
	  <option v-else-if="!isMasked" :value="MASK_DEFAULT">{{ env.msg('formEditor.maskDefault') }}</option>
  </select>
</template>

<script setup lang="ts">
import useEditor, {type PartProps, partProps} from "../Part";
import {computed, ref, watch} from "vue";
import {injectMaskingLib, UNMASK_ALL, MASK_DEFAULT} from "../Masking";
import {injectEnv} from "../Environment";
import type {Unmask} from "@t/fd/editor/Unmask";

const uprops = defineProps({ ...partProps });
const props = uprops as PartProps;

//const um = computed<Unmask>(() => props.part as Unmask);

const { visible, clazz, style } = useEditor(props);
const { maskedList, overrideMask } = injectMaskingLib();
const value = ref<string>("");
const env = injectEnv();
const isMasked = computed(() => maskedList.value.length > 0);
const maskedMany = computed(() => maskedList.value.length > 4);

watch(() => value.value, (n:string, o:string)=> {
  if (n) overrideMask(n);
  value.value = "";
});
</script>
